// extracted by mini-css-extract-plugin
module.exports = {"text":"sort_item-module__text--1eZME"};